<template>
    <b-modal
      v-model="visible"
      :header-bg-variant="'secondary'"
      size="lg"
      no-close-on-backdrop
      hide-footer
    >
      <template v-slot:modal-header="{ close }">
        <h4 class="text-white">Importar Datos</h4>
        <b-button squared size="sm" variant="outline-success" @click="onClose">X</b-button>
      </template>
      <div>
        <h4 class="font-weight-bold">Nota:</h4>
        <p>Por favor revisar la siguiente imagen, mantener el mismo formato de celdas, ubicación y textos en cada una de los archivos a cargar.</p>
        <img src="img/excel.png" style="width:100%;">
        <p>
          <h5><u>Carga de archivos</u></h5>
          <div class="filepond-container">
            <label class="filepond-label">
              <input type="file" ref="fileInput" @change="handleFileChange" accept=".xlsx,.xls" />
              <div class="filepond-label-inner">
                <span>{{ label }}</span>
              </div>
              <button @click="uploadFile" :disabled="uploading">
                {{ buttonText }}
              </button>
            </label>
            <div class="filepond-progress" v-if="uploading">
              <div class="filepond-progress-inner" :style="{ width: uploadProgress + '%' }"></div>
            </div>
          </div>
        </p>
      </div>
    </b-modal>
  </template>
  <script>
  import BoxService from '../../../services/box.service'

  export default {
    props: {
      box_id: String,
      visible: Boolean,
      label: {
        type: String,
        default: 'Arrastre y suelte o haga click para cargar el archivo de Excel',
      },
      buttonText: {
        type: String,
        default: 'Subir',
      },
    },

    data() {
      return {
        file: null,
        uploading: false,
        uploadProgress: 0,
      };
    },
  
    methods: {
      onClose() {
        this.$emit("hide")
      },
  
      onSubmit() {
        this.$emit("submit")
      },

      handleFileChange(event) {
        this.file = event.target.files[0];
      },

      async uploadFile() {
        if (!this.file) return;
  
        this.uploading = true;
        const formData = new FormData();
        formData.append('file', this.file);
        formData.append('caja_id', this.box_id);
  
        try {
          const response = await BoxService.uploadFolder(formData, {
            onUploadProgress: (progressEvent) => {
              this.uploadProgress = Math.round(
                (progressEvent.loaded / progressEvent.total) * 100
              );
            },
          });
  
          if (response.status === 200) {
            this.onSubmit()
          }
          
        } finally {
          this.uploading = false;
          this.uploadProgress = 0;
          this.file = null;
        }
      },
    }
  }
  </script>

<style scoped>
  .filepond-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 20px;
  }

  .filepond-label {
    display: flex;
    flex-direction: column;
    align-items: center;
    border: 2px dashed #006b04;
    padding: 20px;
    cursor: pointer;
    width: 100%;
    text-align: center;
    background-color: #f3f3f3;
    color: #006b04;
  }

  .filepond-label-inner {
    margin-top: 10px;
  }

  .filepond-label span {
    font-size: 16px;
  }

  .filepond-label button {
    margin-top: 10px;
    background-color: #287729;
    color: #fff;
    border: none;
    padding: 8px 20px;
    border-radius: 4px;
    cursor: pointer;
  }

  .filepond-progress {
    width: 100%;
    background-color: #287729;
    height: 10px;
    margin-top: 10px;
  }

  .filepond-progress-inner {
    background-color: #287729;
    height: 100%;
  }

  input[type=file] {
    width: 500px;
    max-width: 100%;
    color: #444;
    padding: 15px;
    background: #fff;
    border-radius: 10px;
    border: 1px solid #555;
  }

  .filepond-label input[type="file"]::-webkit-file-upload-button {
    visibility: hidden;
    display: none;
  }

  input[type="file"]::before {
    content: 'Seleccionar';
    margin-right: 20px;
    border: none;
    background: #287729;
    padding: 10px 20px;
    border-radius: 10px;
    color: #fff;
    cursor: pointer;
    transition: background .2s ease-in-out;
  }

</style>
  